import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './style.css'
import Home from './views/home'
import SyllabusUploadPlanner from './views/syllabus-upload-planner'
import AIStudyHelper from './views/ai-study-helper'
import AccountSubscriptions from './views/account-subscriptions'
import Login from './views/login'
import SignUp from './views/sign-up'
import Dashboard from "./views/dashboard"; 
import NotFound from './views/not-found'
import AuthCallback from './views/auth-callback'


const App = () => {
  return (
    <Router>
     <Switch>
  <Route component={Home} exact path="/" />
  <Route component={SyllabusUploadPlanner} exact path="/syllabus-upload-planner" />
  <Route component={AIStudyHelper} exact path="/ai-study-helper" />
  <Route component={AccountSubscriptions} exact path="/account-subscriptions" />
  <Route component={Login} exact path="/login" />
  <Route component={SignUp} exact path="/sign-up" />
  <Route component={AuthCallback} exact path="/auth/callback" />
  <Route component={Dashboard} exact path="/dashboard" />
  <Route component={NotFound} path="*" />
</Switch>
  </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
